/* eslint-disable array-callback-return */
/* eslint-disable no-unused-vars */
/* eslint-disable no-useless-concat */
/* eslint-disable eqeqeq */
/* eslint-disable no-redeclare */
/* eslint-disable no-use-before-define */
import Highcharts from 'highcharts/highstock';
import authentication from './Authentication';
import { formatGraphTitle } from './HelperFunctions';

require('highcharts/modules/accessibility');
require('highcharts/modules/draggable-points');
require('highcharts/modules/exporting');
require('highcharts/modules/export-data');

var elexity = elexity || {};
elexity.gx = elexity.gx || {};

elexity.gx.solarTrends = {
  // Properties
  entityKey: '',
  activeGraph: '',
  graphType: '',
  dateRange: [],
  frequency: '',
  graphTitle: '',
  graphSubTitle: '',
  campusTimeZone: '',

  // Chart instances
  charts: {},

  // Chart configurations
  chartConfigs: {
    performance: {
      url: '',
      divName: '',
      seriesDefinitions: [
        { name: 'Grid Consumed', color: '#00DC92' },
        { name: 'Solar Consumed', color: '#F96138' },
        { name: 'Solar Exported', color: '#004C93' },
      ],
      seriesUnits: ['kWh', '%', 'kWh'],
      seriesDataMapping: [0, 1, 2],
    },
    selfConsumption: {
      url: '',
      divName: '',
      seriesDefinitions: [
        { name: 'Grid Consumed', color: '#00DC92' },
        { name: 'Solar Consumed', color: '#FA974F' },
        { name: 'Solar Power Exported', color: '#004C93' },
      ],
      seriesUnits: ['kWh', 'kWh', 'kWh'],
      seriesDataMapping: [3, 4, 5],
    },
    generationUse: {
      url: '',
      divName: '',
      seriesDefinitions: [
        { name: 'Solar Consumed', color: '#FA974F' },
        { name: 'Solar Exported', color: '#004C93' },
        { name: 'Grid Consumed', color: '#069BCE' },
        { name: 'Solar Generated', color: '#00DC92' },
      ],
      seriesUnits: ['kWh', 'kWh', 'kWh', 'kWh'],
      seriesDataMapping: [6, 7, 8, 9],
    },
  },

  // --- Helper Functions ---

  logAndLoad: async function (url, callback, onDataLoadedCallback) {
    try {
      const response = await fetch(url, { headers: this.authToken });
      if (!response.ok) {
        if (response.status === 401) {
          authentication.logout();
          window.location.replace(authentication.logoutLink);
        }
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const jsonData = await response.json();

      elexity.gx.solarTrends.campusTimeZone = jsonData.timeZoneCode;
      callback(jsonData);

      if (onDataLoadedCallback) {
        onDataLoadedCallback(jsonData);
      }
    } catch (error) {
      console.error('Failed to fetch graph data:', error);
    }
  },

  buildDateString: function (ts, tz) {
    const format = new Intl.DateTimeFormat('en-GB', {
      year: 'numeric',
      month: 'short',
      day: 'numeric',
      timeZone: tz,
    });
    return format.format(new Date(ts));
  },

  // --- Core Functions ---

  initAuth: function (authToken) {
    this.authToken = authToken;
  },

  init: function (
    entityKey,
    url,
    divName,
    activeGraph,
    graphType,
    dateRange,
    frequency,
    onDataLoadedCallback,
    graphSubTitle
  ) {
    if (!entityKey) return;

    this.charts = {};

    elexity.gx.solarTrends.entityKey = entityKey;
    elexity.gx.solarTrends.activeGraph = activeGraph;
    elexity.gx.solarTrends.graphType = graphType;
    elexity.gx.solarTrends.frequency = frequency;
    elexity.gx.solarTrends.dateRange = dateRange;
    elexity.gx.solarTrends.graphTitle = `Solar ${formatGraphTitle(activeGraph)}`;
    elexity.gx.solarTrends.graphSubTitle = graphSubTitle;

    const config = elexity.gx.solarTrends.chartConfigs[activeGraph];

    if (config) {
      config.url = url.replaceAll('{entityKey}', entityKey) + '&groupBy=' + frequency;
      config.divName = divName;

      this.pulseGraphData(onDataLoadedCallback);

      // this.intervalId = setInterval(() => {
      //     this.pulseGraphData(onDataLoadedCallback);
      // }, 15000);
    }
  },

  createBaseChartDefinition: function (type, yAxisTitle, plotOptions, tooltipFormatter) {
    return {
      title: { text: this.graphTitle },
      subtitle: { text: this.graphSubTitle },
      chart: {
        type: type,
        zooming: { mouseWheel: { enabled: false } },
        style: { fontFamily: 'Inter' },
      },
      rangeSelector: { enabled: false },
      navigator: { enabled: false },
      scrollbar: { enabled: false },
      credits: { enabled: false },
      legend: {
        enabled: true,
        itemStyle: { color: '#02222B' },
      },
      yAxis: [
        {
          lineWidth: 1,
          title: { text: yAxisTitle },
          labels: { style: { color: '#02222B' } },
          opposite: false,
        },
      ],
      xAxis: {
        labels: {
          formatter: function () {
            return this.value;
          },
          rotation: -45,
          style: { color: '#02222B' },
        },
        type: 'category',
      },
      time: { timezone: this.campusTimeZone, useUTC: false },
      plotOptions: plotOptions,
      series: [],
      exporting: {
        buttons: {
          contextButton: {
            menuItems: [
              'viewFullscreen',
              'printChart',
              'separator',
              'downloadCSV',
              'downloadXLS',
              'viewData',
            ],
          },
        },
      },
      tooltip: {
        shared: true,
        crosshairs: true,
        useHTML: true,
        borderWidth: 0,
        formatter: tooltipFormatter,
      },
    };
  },

  createBasePieDefinition: function () {
    return {
      title: { text: this.graphTitle },
      subtitle: { text: this.graphSubTitle },
      chart: {
        type: 'pie',
        style: { fontFamily: 'Inter' },
        zooming: { mouseWheel: { enabled: false } },
        panning: { enabled: false },
      },
      credits: { enabled: false },
      rangeSelector: { enabled: false },
      navigator: { enabled: false },
      scrollbar: { enabled: false },
      legend: {
        enabled: false,
        itemStyle: { color: '#02222B' },
      },
      plotOptions: {
        pie: {
          allowPointSelect: true,
          cursor: 'pointer',
          dataLabels: [{ enabled: true, distance: 20 }],
          showInLegend: true,
        },
      },
      series: [{ data: [] }],
      exporting: {
        buttons: {
          contextButton: {
            menuItems: [
              'viewFullscreen',
              'printChart',
              'separator',
              'downloadCSV',
              'downloadXLS',
              'viewData',
            ],
          },
        },
      },
      tooltip: {
        headerFormat: '',
        pointFormat: '<b>{point.name}</b>: {point.percentage:.1f} %',
      },
    };
  },

  sleep: function (ms) {
    return new Promise((resolve) => setTimeout(resolve, ms));
  },

  initializeGraph: async function (graphData) {
    const config = this.chartConfigs[this.activeGraph];
    const divName = config.divName;
    const chartType = this.graphType;

    if (this.charts[divName]) {
      const currentType = this.charts[divName].options.chart.type;
      const newType = chartType === 'pie' ? 'pie' : 'column';
      if (currentType !== newType) {
        this.charts[divName].destroy();
        this.charts[divName] = null;
      }
    }

    if (!this.charts[divName]) {
      let chartDefinition;
      let plotOptions;
      let tooltipFormatter;

      switch (this.activeGraph) {
        case 'performance':
          plotOptions = { series: { stacking: null, cropThreshold: 'infinity' } };
          tooltipFormatter = function () {
            const dateString = this.points[0].series.xAxis.categories[this.x];
            let s = `<table style="width: 200px; font-size: smaller;"><tr><th colspan="2">${dateString}</th></tr>`;
            this.points.forEach((point, index) => {
              if (point.y !== null) {
                let unit = elexity.gx.solarTrends.chartConfigs.performance.seriesUnits[index];
                s += `<tr><td style="color: #02222B">${point?.series.name}</td><td style="text-align: right"><b>${point.y.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')} ${unit}</b></td></tr>`;
              }
            });
            return s;
          };
          chartDefinition = this.createBaseChartDefinition(
            'column',
            'kWh',
            plotOptions,
            tooltipFormatter
          );
          chartDefinition.yAxis.push({
            lineWidth: 1,
            title: { text: '%' },
            opposite: true,
            labels: { style: { color: '#02222B' } },
            min: 0,
            max: 100,
          });
          break;
        case 'selfConsumption':
          if (chartType === 'pie') {
            chartDefinition = this.createBasePieDefinition();
          } else {
            plotOptions = { series: { stacking: 'normal', cropThreshold: 'infinity' } };
            tooltipFormatter = function () {
              const dateString = this.points[0].series.xAxis.categories[this.x];
              let s = `<table style="width: 200px; font-size: smaller;"><tr><th colspan="2">${dateString}</th></tr>`;
              this.points.forEach((point, index) => {
                if (point.y !== null) {
                  let unit = elexity.gx.solarTrends.chartConfigs.selfConsumption.seriesUnits[index];
                  s += `<tr><td style="color: #02222B">${point?.series.name}</td><td style="text-align: right"><b>${point.y.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')} ${unit}</b></td></tr>`;
                }
              });
              return s;
            };
            chartDefinition = this.createBaseChartDefinition(
              'column',
              'kWh',
              plotOptions,
              tooltipFormatter
            );
          }
          break;
        case 'generationUse':
          plotOptions = {
            series: { stacking: 'normal', turboThreshold: 0, cropThreshold: 'infinity' },
          };
          tooltipFormatter = function () {
            const dateString = this.points[0].series.xAxis.categories[this.x];
            let s = `<table style="width: 200px; font-size: smaller;"><tr><th colspan="2">${dateString}</th></tr>`;
            this.points.forEach((point, index) => {
              if (point.y !== null) {
                let unit = elexity.gx.solarTrends.chartConfigs.generationUse.seriesUnits[index];
                s += `<tr><td style="color: #02222B">${point?.series.name}</td><td style="text-align: right"><b>${point.y.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')} ${unit}</b></td></tr>`;
              }
            });
            return s;
          };
          chartDefinition = this.createBaseChartDefinition(
            'column',
            'kWh',
            plotOptions,
            tooltipFormatter
          );
          break;
        default:
          plotOptions = { series: { stacking: null, cropThreshold: 'infinity' } };
          tooltipFormatter = function () {
            return '';
          };
          chartDefinition = this.createBaseChartDefinition(
            'column',
            'kWh',
            plotOptions,
            tooltipFormatter
          );
          break;
      }

      var domDiv = document.getElementById(divName);

      while (!domDiv) {
        await this.sleep(1000);
        domDiv = document.getElementById(divName);
      }
      this.charts[divName] = Highcharts.stockChart(divName, chartDefinition);
    }

    this.renderGraph(graphData);
  },

  renderGraph: function (graphData) {
    const { activeGraph, graphType } = this;
    const from = this.dateRange[0]?.value;
    const to = this.dateRange[1]?.value;

    const chart = this.charts[this.chartConfigs[activeGraph].divName];
    if (!chart) return;

    if (chart.options.chart.type === 'pie') {
      this.renderPieChart(graphData);
    } else {
      this.renderBarChart(graphData);
    }

    chart.redraw();
    chart.hideLoading();
  },

  renderBarChart: function (graphModel) {
    const { activeGraph, chartConfigs, charts, dateRange } = this;
    const config = chartConfigs[activeGraph];
    const chart = charts[config.divName];

    let from = dateRange[0]?.value;
    let to = dateRange[1]?.value;

    const apiSeriesNames = graphModel.seriesNames.slice(
      config.seriesDataMapping[0],
      config.seriesDataMapping[config.seriesDataMapping.length - 1] + 1
    );

    let seriesDataArrays = apiSeriesNames.map(() => []);
    let xAxisCategories = [];

    if (graphModel.entries) {
      graphModel.entries.forEach((entry) => {
        const timestamp = new Date(entry.timestamp).getTime();
        if (this.withinRange(timestamp, from, to)) {
          xAxisCategories.push(this.buildDateString(entry.timestamp, graphModel.timeZoneCode));

          apiSeriesNames.forEach((seriesName, seriesIndex) => {
            const mDataIndex = graphModel.seriesNames.indexOf(seriesName);
            let yValue = mDataIndex > -1 ? entry.values[mDataIndex] : null;

            if (activeGraph === 'performance' && seriesIndex === 1) {
              yValue = yValue !== null ? Math.ceil(yValue * 100) : null;
            } else {
              yValue = yValue !== null ? Math.ceil(yValue) : null;
            }

            seriesDataArrays[seriesIndex].push(yValue);
          });
        }
      });
    }

    apiSeriesNames.forEach((seriesName, seriesIndex) => {
      const series = chart.series[seriesIndex];
      const seriesColor = config.seriesDefinitions[seriesIndex]?.color;
      if (series) {
        series.setData(seriesDataArrays[seriesIndex], false, false);
        if (activeGraph === 'performance' && seriesIndex === 1) {
          series.update(
            {
              name: seriesName,
              color: seriesColor,
              type: 'spline',
              yAxis: 1,
            },
            false
          );
        } else {
          series.update(
            {
              name: seriesName,
              color: seriesColor,
              type: 'column',
              yAxis: 0,
            },
            false
          );
        }
      } else {
        chart.addSeries(
          {
            name: seriesName,
            color: seriesColor,
            data: seriesDataArrays[seriesIndex],
            type: activeGraph === 'performance' && seriesIndex === 1 ? 'spline' : 'column',
            yAxis: activeGraph === 'performance' && seriesIndex === 1 ? 1 : 0,
          },
          false
        );
      }
    });

    chart.update(
      {
        xAxis: [{ categories: xAxisCategories }],
        tooltip: {
          formatter: function () {
            const dateString = this.points[0].series.xAxis.categories[this.x];
            let s = `<table style="width: 200px; font-size: smaller;"><tr><th colspan="2">${dateString}</th></tr>`;
            this.points.forEach((point, index) => {
              if (point.y !== null) {
                let unit = config.seriesUnits[index];
                s += `<tr><td style="color: #02222B">${point?.series.name}</td><td style="text-align: right"><b>${point.y.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')} ${unit}</b></td></tr>`;
              }
            });
            return s;
          },
        },
      },
      false
    );
  },

  renderPieChart: function (graphModel) {
    const { activeGraph, chartConfigs, charts, dateRange } = this;
    const config = chartConfigs[activeGraph];
    const chart = charts[config.divName];

    let from = dateRange[0]?.value;
    let to = dateRange[1]?.value;

    const apiSeriesSlice = graphModel.seriesNames.slice(
      config.seriesDataMapping[0],
      config.seriesDataMapping[config.seriesDataMapping.length - 1] + 1
    );

    let filteredData = [];
    if (graphModel.entries && typeof from === 'number' && typeof to === 'number') {
      filteredData = graphModel.entries.filter((entry) => {
        const entryTime = new Date(entry.timestamp).getTime();
        return this.withinRange(entryTime, from, to);
      });
    }

    const totals = {};
    let totalSum = 0;

    filteredData.forEach((entry) => {
      apiSeriesSlice.forEach((seriesName) => {
        const mDataIndex = graphModel.seriesNames.indexOf(seriesName);
        const value = mDataIndex > -1 ? entry.values[mDataIndex] : 0;
        totals[seriesName] = (totals[seriesName] || 0) + value;
        totalSum += value;
      });
    });

    const pieSeries = [];
    if (totalSum > 0) {
      config.seriesDefinitions.forEach((seriesDef) => {
        const name = seriesDef.name;
        const value = totals[name] || 0;
        if (value > 0) {
          const y = (value / totalSum) * 100;
          pieSeries.push({
            name: name,
            y: y,
            color: seriesDef.color,
          });
        }
      });
    }

    chart.series[0].setData(pieSeries, false);
  },

  getNameToIndexMap: function (seriesArray) {
    var mNameToIndexMap = {};
    if (seriesArray) {
      seriesArray.forEach((seriesName, index) => {
        mNameToIndexMap[seriesName] = index;
      });
    }
    return mNameToIndexMap;
  },

  withinRange: function (value, from, to) {
    return value >= from && value <= to;
  },

  pulseGraphData: function (onDataLoadedCallback) {
    const config = this.chartConfigs[this.activeGraph];
    if (config) {
      const chartExists = !!this.charts[config.divName];
      const callback = chartExists ? this.renderGraph.bind(this) : this.initializeGraph.bind(this);
      this.logAndLoad(config.url, callback, onDataLoadedCallback);
    }
  },
};

export { elexity };
